import type { ShippingProfilesResponse } from '../../../Shipping.types'
import type { ShippingGroup } from '../ShippingGroupsYouShip.types'

export const getShippingGroups = (
  shippingProfilesResponse: ShippingProfilesResponse | undefined,
): ShippingGroup[] => {
  if (!shippingProfilesResponse || shippingProfilesResponse.shippingProfiles.length === 0) {
    return []
  }

  return shippingProfilesResponse.shippingProfiles.map((profile, index) => ({
    id: profile.id || `shippingGroup${index}`,
    offerIds: profile.offerIds,
    countries: profile.countries,
  }))
}
